import styled from 'styled-components';
import Block from '../Block';

export const StyledBlock = styled(Block)`
  background: ${({ theme }) => theme.colors.white};
`;
